import {useDebugValue} from 'react';

import {DEFAULT_FIELD_AUTO_PROGRESS_TYPE} from '../../../utils/field';

import {runSearchFormColourContrastAndLabelsExperiment} from '../../../utils/experiments';

import {useOptions} from './useOptions';

const defaultFormOptions = {
    allowErrorHighlighting: false,
    allowSummary: false,
    autoProgress: DEFAULT_FIELD_AUTO_PROGRESS_TYPE,
    autoSubmit: true,
    isColourContrastAndLabels: false,
    layout: 'standard',
    align: 'center',
    showIcons: true,
    showGuestsDetailsInputField: true,
    showSubmitDetailsButtonField: true
};

function useFormOptions(props, abacusStore) {
    const {
        formOptions: propsFormOptions
    } = props;

    const showColorContrastExperiment = runSearchFormColourContrastAndLabelsExperiment({shouldLogExperiment: true}, abacusStore) || false;

    const experimentFormOptions = {
        isColourContrastAndLabels: showColorContrastExperiment
    };

    const {
        options: formOptions
    } = useOptions(defaultFormOptions, experimentFormOptions, propsFormOptions);

    const result = {
        formOptions
    };

    useDebugValue(result);

    return result;
}

export {useFormOptions};
